export const getLocaleFormattedDate = (date: Date | string | number, localeName: string = navigator.language) => {
    return new Intl.DateTimeFormat(localeName, {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    }).format(new Date(date));
};
